var map = {
	"./ADA.svg": 892,
	"./BCH.svg": 893,
	"./BNB.svg": 894,
	"./BTC.svg": 895,
	"./CHZ.svg": 896,
	"./DASH.svg": 897,
	"./DOGE.svg": 898,
	"./DOT.svg": 899,
	"./ETC.svg": 900,
	"./ETH.svg": 901,
	"./EUR.svg": 902,
	"./GBP.svg": 903,
	"./LINK.svg": 904,
	"./LTC.svg": 905,
	"./MATIC.svg": 906,
	"./MKR.svg": 907,
	"./SHIB.svg": 908,
	"./SOL.svg": 909,
	"./TRX.svg": 910,
	"./UNI.svg": 911,
	"./USD.svg": 912,
	"./USDT.svg": 913,
	"./XLM.svg": 914,
	"./XMR.svg": 915,
	"./XRP.svg": 916,
	"./documents.svg": 917
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 891;